import React from 'react';
import { Grid, Typography } from '@mui/material';
import { t } from 'i18next';

interface BakeasyLabelTextProps {
  label: string;
  value: any;
  required?: boolean;
  disabled?: boolean;
  maxLength?: number;
  style?: React.CSSProperties;
  alignment?: string;
}

function BakeasyLabelText(props: BakeasyLabelTextProps) {
  return (
    <Grid marginTop={0.5}>
      <Typography sx={{ fontWeight: 'bold', paddingBottom: 0.5 }}>{t(props.label)}</Typography>
      <Typography>{props.value}</Typography>
    </Grid>
  );
}

export default BakeasyLabelText;
